import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import 'Pages/SuperAdmin/Dashboard/dashboard.scss';
import rightArrow from 'assets/images/Dashboard/arrow-right.png';
import addIcon from 'assets/images/Dashboard/add.png';
import mail from 'assets/images/Dashboard/mail.png';
import call from 'assets/images/Dashboard/call.png';
import trash from 'assets/images/Dashboard/trash.png';
import ReusableTabs from 'components/common/Tabs';
import { FormattedMessage, useIntl } from 'react-intl';
import ReusableButton from 'components/common/Button';
import {
  superAdminAddProvider,
  superAdminCompanyProviderDetails,
  superAdminNewRequestProvider,
  superAdminOnHoldProvider,
  superAdminSalonProviderDetails,
  superAdminSpecialistProviderDetails,
} from 'routes/AppUrls';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProviderListCallAPI } from 'store/SuperAdmin/getAllProviderList/action';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import { getAllProviderInformationDetailsCallAPI } from 'store/SuperAdmin/getAllProviderInformation/action';
import { deleteProviderSuperAdminCallAPI } from 'store/SuperAdmin/deleteProvider/action';
import {
  basicDetailsCallApi,
  PROVIDER_SELECTED_TAB,
} from 'store/SuperAdmin/basicDetails/action';
import { useConfirm } from 'material-ui-confirm';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import InputAdornment from '@mui/material/InputAdornment';
import searchIcon from 'assets/images/navbar/search.svg';
import SelectInput from 'components/common/Input/SelectInput';
import crossIcon from 'assets/images/provider/crossIcon.png';
import { DateRangePicker } from 'react-date-range';
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style
import 'react-date-range/dist/theme/default.css'; // theme css
import CommonModal from 'components/common/Modal';
import { Box } from '@mui/system';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CircularProgress from '@mui/material/CircularProgress';
import { getAllProviderExportListCallAPI } from 'store/SuperAdmin/ProviderExport/action';
import SwitchInput from 'components/common/Input/SwitchInput';
import { getSearchProviderCallAPI } from 'store/SuperAdmin/searchProviderList/action';
import { countryCityDropdownCallAPI } from 'store/CountryCityList/action';
import { updateProviderStatusCallAPI } from 'store/SuperAdmin/updateProviderStatus/action';
import ToastNotification from 'components/common/Toast';
import { ShimmerBox } from 'components/common/Shimmer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const SuperAdminProvider = () => {
  const navigate = useNavigate();
  const confirm = useConfirm();
  const [conf, setConf] = ToastNotification();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);

  const getProviderSelectedTab = useSelector(
    (state) => state?.basicDetailsReducer?.providerSelectedTab
  );

  const countryCityData = useSelector(
    (state) => state?.countryCityDropdownReducer?.data?.data
  );

  const [tab, setTab] = useState(getProviderSelectedTab);
  const [page, setPage] = useState(1); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Items per page
  const [searchValue, setSearchValue] = useState('');
  const [selectSort, setSelectSort] = useState('');
  const [selectSortName, setSelectSortName] = useState('');
  const [selectSortOrder, setSelectSortOrder] = useState('');
  const [selectFilter, setSelectFilter] = useState('');
  const [selectFilterName, setSelectFilterName] = useState('');
  const [selectCountry, setSelectCountry] = useState('');
  const [selectCity, setSelectCity] = useState('');
  const [isModalActive, setIsModalActive] = useState(false);
  const [loading, setLoading] = useState(true);

  const getAllProviderData = useSelector(
    (state) => state?.getAllProviderListReducer?.data
  );

  const getAllProviderLoading = useSelector(
    (state) => state?.getAllProviderListReducer?.loading
  );

  const searchProviderLoading = useSelector(
    (state) => state?.getSearchProviderReducer?.loading
  );

  const providerLoading = getAllProviderLoading;

  const [totalPages, setTotalPages] = useState(
    Math.ceil((getAllProviderData?.count || 0) / rowsPerPage)
  );

  const [allProviderList, setAllProviderList] = useState(
    getAllProviderData?.results?.data ? getAllProviderData?.results?.data : []
  );

  useEffect(() => {
    setLoading(true);
    handleTabChange(tab);
    getCountryCityList();
  }, []);

  const getCountryCityList = () => {
    dispatch(countryCityDropdownCallAPI({}, { naviagte: navigate }));
  };

  const getAllProvider = (page = 1, slug = '') => {
    let data = { pageSize: rowsPerPage, pageNumber: page, slug: slug };
    dispatch(
      getAllProviderListCallAPI(
        { data },
        {
          run: true,
          handleFunction: (res) => {
            handleSuccess(res);
            setLoading(false);
          },
          navigate: navigate,
        }
      )
    );
  };

  const handleSuccess = (res) => {
    setAllProviderList(res?.data?.results?.data);
    setTotalPages(Math.ceil((res?.data?.count || 0) / rowsPerPage));
  };

  // const tabData = [
  //   { label: intl.formatMessage({ id: 'All Providers' }) },
  //   { label: intl.formatMessage({ id: 'New Requests' }) },
  //   { label: intl.formatMessage({ id: 'On Hold' }) },
  //   { label: intl.formatMessage({ id: 'Requested' }) },
  // ];

  const tabData = [
    // { label: intl.formatMessage({ id: 'All Providers' }) },
    { label: intl.formatMessage({ id: 'New Requests' }) },
    { label: intl.formatMessage({ id: 'In Review' }) },
    { label: intl.formatMessage({ id: 'Approved' }) },
    { label: intl.formatMessage({ id: 'On Hold' }) },
    { label: intl.formatMessage({ id: 'Requested' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
    dispatch(basicDetailsCallApi(PROVIDER_SELECTED_TAB, val));
    setPage(1);
    switch (val) {
      case 1:
        getAllProvider(1, 'new_request');
        break;
      case 2:
        getAllProvider(1, 'in_review');
        break;
      case 3:
        getAllProvider(1, 'approved');
        break;
      case 4:
        getAllProvider(1, 'on-hold');
        break;
      case 5:
        getAllProvider(1, 'new_request');
        break;
    }
  };

  const AllProviderInformationApi = (data) => {
    switch (data?.business_type) {
      case 'specialist':
        navigate(superAdminSpecialistProviderDetails(locale), {
          state: { data },
        });
        break;
      case 'salon':
        navigate(superAdminSalonProviderDetails(locale), {
          state: { data },
        });
        break;
      case 'branch-company':
        navigate(superAdminSalonProviderDetails(locale), {
          state: { data },
        });
        break;
      case 'company':
        navigate(superAdminCompanyProviderDetails(locale), {
          state: { data },
        });
        break;
    }
  };

  const handleViewDetails = (data, index) => {
    switch (tab) {
      case 1:
        navigate(superAdminNewRequestProvider(locale), {
          state: { id: data?.id, type: tab },
        });
        break;
      case 2:
        navigate(superAdminOnHoldProvider(locale), {
          state: { id: data.id, type: tab },
        });
        break;
      case 3:
        navigate(superAdminOnHoldProvider(locale), {
          state: { id: data.id, type: tab },
        });
        break;
      case 4:
        navigate(superAdminOnHoldProvider(locale), {
          state: { id: data.id, type: tab },
        });
        break;
      case 5:
        navigate(superAdminNewRequestProvider(locale), {
          state: { id: data?.id, type: tab },
        });
        break;
    }
  };

  const handleDeleteProvider = (data, index) => {
    confirm({
      title: 'Confirm Delete',
      description: 'Are you sure you want to delete Provider ?',
      confirmationText: 'Yes',
      cancellationText: 'No',
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          border: '1px solid #292D32',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleConfirmDeleteProvider(data, index))
      .catch(() => console.log('Deletion cancelled.'));
  };

  const handleConfirmDeleteProvider = (data, index) => {
    dispatch(
      deleteProviderSuperAdminCallAPI(
        {},
        {
          id: data?.id,
          run: true,
          handleFunction: (res) => getAllProvider(page),
          navigate: navigate,
        }
      )
    );
  };

  ////////// Pagination ////////////////////
  const handlePageChange = (event, value) => {
    setPage(value);
    switch (tab) {
      case 1:
        getSearchProviderData(
          value,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 2:
        getAllProvider(value, 'new_request');
        break;
      case 3:
        getAllProvider(value, 'on-hold');
        break;
      case 4:
        getAllProvider(value, 'new_request');
        break;
    }
  };
  ////////// Pagination ////////////////////

  const handleSearch = (searchValues) => {
    setSearchValue(searchValues);
    setPage(1);
    if (searchValues === '') {
      getSearchProviderData(
        1,
        '',
        selectSort,
        selectSortOrder,
        selectFilter,
        selectCountry,
        selectCity,
        selectDateRange
      );
    } else {
      getSearchProviderData(
        1,
        searchValues,
        selectSort,
        selectSortOrder,
        selectFilter,
        selectCountry,
        selectCity,
        selectDateRange
      );
    }
  };

  const handleSearchClear = (name) => {
    setPage(1);
    switch (name) {
      case 'search':
        setSearchValue('');
        getSearchProviderData(
          1,
          '',
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'sort':
        setSelectSort('');
        setSelectSortName('');
        setSelectSortOrder('');
        getSearchProviderData(
          1,
          searchValue,
          '',
          '',
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'filter':
        setSelectFilter('');
        setSelectFilterName('');
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          '',
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'country':
        setSelectCountry('');
        setSelectCity('');
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          '',
          '',
          selectDateRange
        );
        break;
      case 'city':
        setSelectCity('');
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          '',
          selectDateRange
        );
        break;
    }
  };

  const getSearchProviderData = (
    page,
    searchValue,
    searchSort,
    searchSortOrder,
    searchFilter,
    searchCountry,
    searchCity,
    selectDateRange
  ) => {
    let body = {
      page_size: rowsPerPage,
      page: page,
      search_text: searchValue,
      sort_by: searchSort,
      sort_order: searchSortOrder,
      status: searchFilter,
      country: searchCountry,
      city: searchCity,
      start_date: selectDateRange
        ? moment(selectDateRange?.[0]?.startDate)?.format('YYYY-MM-DD')
        : '',
      end_date: selectDateRange
        ? moment(selectDateRange?.[0]?.endDate)?.format('YYYY-MM-DD')
        : '',
      slug: '',
    };
    dispatch(
      getSearchProviderCallAPI(body, {
        run: true,
        handleFunction: (res) => handleSearchSuccess(res),
        navigate: navigate,
      })
    );
  };

  const handleSearchSuccess = (res) => {
    setAllProviderList(res?.data?.results?.data);
    setTotalPages(Math.ceil((res?.data?.count || 0) / rowsPerPage));
  };

  const getSortName = (name) => {
    switch (name) {
      case 'Name (A to Z)':
        return 'name';
      case 'Name (Z to A)':
        return 'name';
      case 'Join Date (Newest to Oldest)':
        return 'join_date';
      case 'Join Date (Oldest to Newest)':
        return 'join_date';
    }
  };

  const getSortOrder = (name) => {
    switch (name) {
      case 'Name (A to Z)':
        return 'asc';
      case 'Name (Z to A)':
        return 'desc';
      case 'Join Date (Newest to Oldest)':
        return 'desc';
      case 'Join Date (Oldest to Newest)':
        return 'asc';
    }
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setPage(1);
    switch (name) {
      case 'sort':
        setSelectSortName(value?.name);
        setSelectSort(getSortName(value?.name));
        setSelectSortOrder(getSortOrder(value?.name));
        getSearchProviderData(
          1,
          searchValue,
          getSortName(value?.name),
          getSortOrder(value?.name),
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'filter':
        setSelectFilterName(value.name);
        setSelectFilter(
          value?.name === 'Active Status' ? 'active' : 'inactive'
        );
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          value?.name === 'Active Status' ? 'active' : 'inactive',
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'country':
        setSelectCountry(value?.name);
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          value?.name,
          selectCity,
          selectDateRange
        );
        break;
      case 'city':
        setSelectCity(value?.name);
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          value?.name,
          selectDateRange
        );
        break;
    }
  };

  const getSortListData = [
    { name: 'Name (A to Z)' },
    { name: 'Name (Z to A)' },
    { name: 'Join Date (Newest to Oldest)' },
    { name: 'Join Date (Oldest to Newest)' },
  ];

  const getFilterListData = [
    { name: 'Active Status' },
    { name: 'InActive Status' },
  ];

  const handleClearAll = () => {
    setSearchValue('');
    setSelectSort('');
    setSelectSortName('');
    setSelectSortOrder('');
    setSelectFilter('');
    setSelectFilterName('');
    setSelectCountry('');
    setSelectCity('');
    setDateRangeState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
    setSelectDateRange('');
    setSelectedLabel('Today');
    getSearchProviderData(page, '', '', '', '', '', '', '');
  };

  ///////////////////////////////////////////////DateRange////////////////

  const [dateRangeState, setDateRangeState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [selectedLabel, setSelectedLabel] = useState('Today');
  const [selectDateRange, setSelectDateRange] = useState('');

  const predefinedRanges = [
    {
      label: 'Today',
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
    },
    {
      label: 'Yesterday',
      range: () => {
        const yesterday = addDays(new Date(), -1);
        return { startDate: yesterday, endDate: yesterday };
      },
    },
    {
      label: 'Last 7 Days',
      range: () => ({
        startDate: addDays(new Date(), -6),
        endDate: new Date(),
      }),
    },
    {
      label: 'Last 30 Days',
      range: () => ({
        startDate: addDays(new Date(), -29),
        endDate: new Date(),
      }),
    },
    {
      label: 'This Month',
      range: () => {
        const now = new Date();
        return {
          startDate: new Date(now.getFullYear(), now.getMonth(), 1),
          endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        };
      },
    },
    {
      label: 'Last Month',
      range: () => {
        const now = new Date();
        return {
          startDate: new Date(now.getFullYear(), now.getMonth() - 1, 1),
          endDate: new Date(now.getFullYear(), now.getMonth(), 0),
        };
      },
    },
  ];

  const handleCloseModel = () => {
    setIsModalActive(false);
  };

  const handleSwitchChange = (event, data) => {
    let body = {
      provider_id: data?.id,
      status: event?.target?.checked,
    };
    dispatch(
      updateProviderStatusCallAPI(body, {
        run: true,
        handleFunction: (res) => handleStatusSuccess(res),
        navigate: navigate,
        toast: true,
        handleToastError: (res) => handleRedirectError(res),
      })
    );
  };

  const handleStatusSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getSearchProviderData(page, '', '', '', '', '', '', '');
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  ///////////////////////////////////////////////DateRange////////////////

  ////////////////////////Export//////////////////////////////////////////

  const handleExportExcel = () => {
    dispatch(
      getAllProviderExportListCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleExportNewWindow(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleExportNewWindow = (res) => {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.data?.data?.length > 0) {
        exportToExcelAndOpenTab(res?.data?.data, 'ProviderList.xls');
      }
    }
  };

  const exportToExcelAndOpenTab = (data, fileName = 'ProviderList.xls') => {
    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((h) => {
              let value = row[h];
              if (h === 'status') {
                value = value === true ? 'Active' : 'Inactive';
              } else if (h === 'name') {
                value = value?.name_en || null;
              } else if (h === 'profile_photo') {
                value = value?.file_url || null;
              }
              return `<td>${value ?? ''}</td>`;
            })
            .join('')}</tr>`
      )
      .join('');

    const table = `
      <table border="1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr style="background-color: #f2f2f2;">
            ${headers.map((h) => `<th style="padding: 8px; text-align: left;">${h?.charAt(0).toUpperCase() + h?.slice(1)}</th>`).join('')}
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    `;

    const newTab = window.open('', '_blank');
    const html = `
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            body { 
              font-family: sans-serif; 
              padding: 0;
              margin: 0;
            }
            .header-container {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 20px;
              background: white;
              z-index: 1000;
              // box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            .header-container h2 {
              margin: 0;
            }
            .content-container {
              margin-top: 80px;
              padding: 20px;
            }
            button, a.download-link {
              padding: 8px 12px;
              margin-right: 10px;
              margin-top: 0px;
              background: #007bff;
              color: white;
              text-decoration: none;
              border: none;
              cursor: pointer;
              border-radius: 4px;
              display: inline-block;
            }
            a.download-link:hover {
              background: #0056b3;
            }
          </style>
        </head>
        <body>
          <div class="header-container">
            <h2>Provider Data</h2>
            <div>
              <a class="download-link" href="#" onclick="downloadExcel(); return false;">⬇️ Download</a>
            </div>
          </div>
          <div class="content-container">
            ${table}
          </div>
          <script>
            function downloadExcel() {
              const tableHTML = document.querySelector('table').outerHTML;
              const blob = new Blob(["\\ufeff" + tableHTML], {
                type: "application/vnd.ms-excel",
              });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "${fileName}";
              a.click();
            }
          </script>
        </body>
      </html>
    `;
    newTab.document.open();
    newTab.document.write(html);
    newTab.document.close();
  };

  ////////////////////////Export//////////////////////////////////////////

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
          <FormattedMessage id="Provider" />
        </h2>

        <Row className="m-0 p-0 mt-3 justify-between">
          <Col md={12} lg={7} xl={7} xxl={6} className="m-0 p-0">
            <ReusableTabs
              tabs={tabData}
              defaultTab={tab}
              currentTab={(val) => handleTabChange(val)}
            />
          </Col>

          {!loading && (
            <Col
              md={12}
              lg={5}
              xl={5}
              xxl={6}
              className="m-0 p-0 flex justify-end"
            >
              <Stack direction="horizontal" gap={4} className="items-center">
                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  height="48px"
                  fontSize="18px"
                  fontWeight="400"
                  padding="12px 35px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  endIcon={
                    false && (
                      <CircularProgress
                        style={{
                          color: 'white',
                          width: '20px',
                          height: '20px',
                        }}
                      />
                    )
                  }
                  onClick={() => handleExportExcel()}
                >
                  <FormattedMessage id="Export to Excel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 35px"
                  height="48px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  onClick={() => navigate(superAdminAddProvider(locale))}
                >
                  <img
                    src={addIcon}
                    alt="icon"
                    style={{ height: '24px', width: '24px' }}
                    className="me-2"
                  />
                  <FormattedMessage id="Add a Provider" />
                </ReusableButton>
              </Stack>
            </Col>
          )}
        </Row>

        {/* {tab === 1 && (
          <>
            <Row className="p-0 mt-3">
              {loading ? (
                <Row className="gx-4">
                  {[1, 2, 3, 4]?.map((index) => (
                    <Col
                      md={12}
                      lg={4}
                      xl={4}
                      xxl={3}
                      className="bg-white p-3"
                      key={index}
                    >
                      <div>
                        <ShimmerBox height={100} width={'100%'} />
                      </div>
                    </Col>
                  ))}
                </Row>
              ) : (
                <>
                  <Col md={12} lg={4} xl={4} xxl={3}>
                    <LabelWithInput
                      placeholder={intl.formatMessage({
                        id: 'Search',
                      })}
                      label={intl.formatMessage({
                        id: 'Search',
                      })}
                      name="search"
                      type="text"
                      marginLabelTop="0"
                      height="48"
                      bgColor="#FFFFFF"
                      value={searchValue}
                      onChange={(e) => handleSearch(e?.target?.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Image
                              src={searchIcon}
                              alt="icon"
                              style={{ cursor: 'pointer' }}
                            />
                            {searchValue ? (
                              <Image
                                src={crossIcon}
                                alt="icon"
                                width={18}
                                height={18}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleSearchClear('search')}
                              />
                            ) : null}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>

                  <Col md={12} lg={4} xl={4} xxl={2}>
                    <SelectInput
                      marginLabelTop={'0'}
                      label={intl.formatMessage({
                        id: 'Sort',
                      })}
                      placeholder={intl.formatMessage({
                        id: 'Sort',
                      })}
                      height="48"
                      name={'sort'}
                      value={selectSortName}
                      data={getSortListData ?? []}
                      onChange={(e) => handleSelectChange(e)}
                      InputProps={{
                        endAdornment: selectSortName ? (
                          <InputAdornment
                            position="end"
                            sx={{ position: 'absolute', right: 5 }}
                          >
                            <Image
                              src={crossIcon}
                              alt="icon"
                              width={18}
                              height={18}
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleSearchClear('sort')}
                            />
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Col>

                  <Col md={12} lg={4} xl={4} xxl={2}>
                    <SelectInput
                      marginLabelTop={'0'}
                      label={intl.formatMessage({
                        id: 'Filter',
                      })}
                      placeholder={intl.formatMessage({
                        id: 'Filter',
                      })}
                      height="48"
                      name={'filter'}
                      value={selectFilterName}
                      data={getFilterListData ?? []}
                      onChange={(e) => handleSelectChange(e)}
                      InputProps={{
                        endAdornment: selectFilterName ? (
                          <InputAdornment
                            position="end"
                            sx={{ position: 'absolute', right: 5 }}
                          >
                            <Image
                              src={crossIcon}
                              alt="icon"
                              width={18}
                              height={18}
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleSearchClear('filter')}
                            />
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Col>

                  <Col md={12} lg={4} xl={4} xxl={2}>
                    <SelectInput
                      marginLabelTop={'0'}
                      label={<FormattedMessage id="Country" />}
                      placeholder={intl.formatMessage({ id: 'Country' })}
                      height="48"
                      name={'country'}
                      value={selectCountry}
                      data={countryCityData}
                      onChange={(e) => handleSelectChange(e)}
                      InputProps={{
                        endAdornment: selectCountry ? (
                          <InputAdornment
                            position="end"
                            sx={{ position: 'absolute', right: 5 }}
                          >
                            <Image
                              src={crossIcon}
                              alt="icon"
                              width={18}
                              height={18}
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleSearchClear('country')}
                            />
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Col>

                  <Col md={12} lg={4} xl={4} xxl={2}>
                    <SelectInput
                      marginLabelTop={'0'}
                      label={<FormattedMessage id="City" />}
                      placeholder={intl.formatMessage({ id: 'City' })}
                      height="48"
                      name={'city'}
                      value={selectCity}
                      data={
                        countryCityData?.find(
                          (value) => value?.name === selectCountry
                        )?.city || []
                      }
                      onChange={(e) => handleSelectChange(e)}
                      InputProps={{
                        endAdornment: selectCity ? (
                          <InputAdornment
                            position="end"
                            sx={{ position: 'absolute', right: 5 }}
                          >
                            <Image
                              src={crossIcon}
                              alt="icon"
                              width={18}
                              height={18}
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleSearchClear('city')}
                            />
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Col>

                  <Col md={12} lg={4} xl={4} xxl={1} className="mt-4">
                    <ReusableButton
                      fullWidth={true}
                      variant="contained"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px"
                      height="48px"
                      bgColor="#292D32"
                      fontFamily="Akkurat"
                      onClick={() => handleClearAll()}
                    >
                      <FormattedMessage id="Clear All" />
                    </ReusableButton>
                  </Col>
                </>
              )}
            </Row>

            {!providerLoading && (
              <>
                <Row className="p-0 mt-3">
                  <Col md={12} lg={4} xl={4} xxl={3}>
                    <LabelWithInput
                      placeholder={intl.formatMessage({
                        id: 'Date Range Filter',
                      })}
                      label={intl.formatMessage({
                        id: 'Date Range Filter',
                      })}
                      name="dateRange"
                      type="text"
                      marginLabelTop="0"
                      height="48"
                      bgColor="#FFFFFF"
                      value={
                        selectDateRange?.length > 0 &&
                        moment(selectDateRange?.[0]?.startDate).isValid() &&
                        moment(selectDateRange?.[0]?.endDate).isValid()
                          ? `${moment(selectDateRange[0].startDate).format('YYYY-MM-DD')} - ${moment(selectDateRange[0].endDate).format('YYYY-MM-DD')}`
                          : ''
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CalendarMonthIcon
                              style={{ cursor: 'pointer' }}
                              onClick={() => setIsModalActive(true)}
                            />
                            {selectDateRange ? (
                              <Image
                                src={crossIcon}
                                alt="icon"
                                width={18}
                                height={18}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                onClick={() => {
                                  setDateRangeState([
                                    {
                                      startDate: new Date(),
                                      endDate: new Date(),
                                      key: 'selection',
                                    },
                                  ]);
                                  setSelectDateRange('');
                                  setSelectedLabel('Today');
                                  getSearchProviderData(
                                    page,
                                    searchValue,
                                    selectSort,
                                    selectSortOrder,
                                    selectFilter,
                                    selectCountry,
                                    selectCity,
                                    ''
                                  );
                                }}
                              />
                            ) : null}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>
                </Row>
              </>
            )}
          </>
        )} */}

        <Row className="mt-3 listHeader m-0 p-0 flex items-center">
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Providers" />
            </p>
          </Col>
          {tab !== 1 && (
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Serving Location" />
              </p>
            </Col>
          )}
          <Col lg={3} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Contact Info" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              {tab === 1 ? (
                <FormattedMessage id="Invited On" />
              ) : (
                <FormattedMessage id="Requested On" />
              )}
            </p>
          </Col>

          {tab === 1 && (
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Promoted" />
              </p>
            </Col>
          )}

          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Actions" />
            </p>
          </Col>
        </Row>

        <Row className="bc-FFFFFF m-0 p-0">
          {providerLoading ? (
            <>
              {[1, 2, 3, 4, 5].map((item) => (
                <Row
                  key={item}
                  className="m-0 p-0 flex items-center listAppointment"
                >
                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="150px" height="14px" />
                  </Col>

                  {tab !== 1 && (
                    <Col lg={3} md={6} sm={12}>
                      <ShimmerBox width="200px" height="12px" />
                    </Col>
                  )}
                  <Col lg={3} md={6} sm={12}>
                    <ShimmerBox width="150px" height="12px" />
                    <ShimmerBox width="120px" height="12px" className="mt-2" />
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="100px" height="14px" />
                  </Col>

                  {tab === 1 && (
                    <Col lg={2} md={6} sm={12}>
                      <ShimmerBox width="50px" height="20px" />
                    </Col>
                  )}

                  <Col lg={2} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={3}
                      className="items-center"
                    >
                      <ShimmerBox width="24px" height="24px" />
                      <ShimmerBox width="100px" height="14px" />
                    </Stack>
                  </Col>
                </Row>
              ))}
            </>
          ) : allProviderList?.length > 0 ? (
            allProviderList.map((key, index) =>
              tab === 1 || tab === 5 ? (
                <>
                  {tab === 5 && key?.is_added_by_admin && (
                    <Row className="m-0 p-0 flex items-center listAppointment">
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {key?.name?.name_en}
                        </p>
                      </Col>

                      <Col lg={3} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                          {key?.address}
                        </p>
                      </Col>
                      <Col lg={3} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center "
                          >
                            <img
                              src={mail}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                              {key?.email}
                            </p>
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center mt-2"
                          >
                            <img
                              src={call}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                              {key?.country_code} {key?.contact_number}
                            </p>
                          </Stack>
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                          {key?.requested_on
                            ? moment(key?.requested_on)?.format('DD MMM YYYY')
                            : ''}
                        </p>
                      </Col>

                      <Col lg={2} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center "
                          onClick={() => handleViewDetails(key, index)}
                        >
                          <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                            <FormattedMessage id="View Details" />
                          </p>
                          <img
                            src={rightArrow}
                            alt="icon"
                            style={{ height: '20px', width: '20px' }}
                          />
                        </Stack>
                      </Col>
                    </Row>
                  )}
                  {tab === 1 && key?.is_added_by_admin === false && (
                    <Row className="m-0 p-0 flex items-center listAppointment">
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {key?.name?.name_en}
                        </p>
                      </Col>

                      {tab !== 1 && (
                        <Col lg={3} md={6} sm={12}>
                          <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                            {key?.address}
                          </p>
                        </Col>
                      )}
                      <Col lg={3} md={6} sm={12}>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center "
                          >
                            <img
                              src={mail}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                              {key?.email}
                            </p>
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center mt-2"
                          >
                            <img
                              src={call}
                              alt="icon"
                              style={{ height: '20px', width: '20px' }}
                            />
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                              {key?.country_code} {key?.contact_number}
                            </p>
                          </Stack>
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                          {key?.requested_on
                            ? moment(key?.requested_on)?.format('DD MMM YYYY')
                            : ''}
                        </p>
                      </Col>
                      {tab === 1 && (
                        <Col lg={2} md={6} sm={12}>
                          <p
                            className={`p-0 m-0 fs-14 fc-fff fw-400 ff-Akkurat_Bold`}
                          >
                            {key?.is_promote ? (
                              <CheckCircleIcon />
                            ) : (
                              <CancelIcon />
                            )}
                          </p>
                        </Col>
                      )}
                      <Col lg={2} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center "
                          onClick={() => handleViewDetails(key, index)}
                        >
                          <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                            <FormattedMessage id="View Details" />
                          </p>
                          <img
                            src={rightArrow}
                            alt="icon"
                            style={{ height: '20px', width: '20px' }}
                          />
                        </Stack>
                      </Col>
                    </Row>
                  )}
                </>
              ) : (
                <Row className="m-0 p-0 flex items-center listAppointment">
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {key?.name?.name_en}
                    </p>
                  </Col>

                  <Col lg={3} md={6} sm={12}>
                    <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                      {key?.address}
                    </p>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center "
                      >
                        <img
                          src={mail}
                          alt="icon"
                          style={{ height: '20px', width: '20px' }}
                        />
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                          {key?.email}
                        </p>
                      </Stack>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center mt-2"
                      >
                        <img
                          src={call}
                          alt="icon"
                          style={{ height: '20px', width: '20px' }}
                        />
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                          {key?.country_code} {key?.contact_number}
                        </p>
                      </Stack>
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                      {tab === 1
                        ? key?.joining_on
                          ? moment(key?.joining_on)?.format('DD MMM YYYY')
                          : ''
                        : key?.requested_on
                          ? moment(key?.requested_on)?.format('DD MMM YYYY')
                          : ''}
                    </p>
                  </Col>

                  {tab === 1 && (
                    <Col lg={2} md={6} sm={12}>
                      <SwitchInput
                        label={true}
                        checked={key?.status}
                        onChange={(e) => handleSwitchChange(e, key)}
                        color="secondary"
                      />
                    </Col>
                  )}

                  <Col lg={2} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center "
                      onClick={() => handleViewDetails(key, index)}
                    >
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                        <FormattedMessage id="View Details" />
                      </p>
                      <img
                        src={rightArrow}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                    </Stack>
                  </Col>
                </Row>
              )
            )
          ) : (
            <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ height: '200px', width: '200px' }}
              />
            </Row>
          )}
        </Row>

        <Row className="mt-3 m-0 p-0">
          <Stack spacing={2} className="p-0">
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
              className="d-flex justify-end"
            />
          </Stack>
        </Row>

        {/* DateRange Select Modal*/}
        <CommonModal
          padding={'32px 48px'}
          width={'800px'}
          modalActive={isModalActive}
          handleClose={() => handleCloseModel()}
          innerContent={
            <Box>
              <Row>
                <DateRangePicker
                  ranges={dateRangeState}
                  onChange={(item) => {
                    setDateRangeState([item.selection]);
                    const selected = predefinedRanges.find(
                      (range) =>
                        range.range().startDate.toDateString() ===
                          item.selection.startDate.toDateString() &&
                        range.range().endDate.toDateString() ===
                          item.selection.endDate.toDateString()
                    );
                    setSelectedLabel(selected?.label || '');
                  }}
                  staticRanges={predefinedRanges.map((range) => ({
                    label: range.label,
                    range: range.range,
                    isSelected() {
                      return selectedLabel === range.label;
                    },
                  }))}
                  inputRanges={[]}
                />

                <Stack
                  direction="horizontal"
                  gap={3}
                  className="items-center cursor-pointer flex justify-end"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={() => {
                      setDateRangeState([
                        {
                          startDate: new Date(),
                          endDate: new Date(),
                          key: 'selection',
                        },
                      ]);
                      setSelectedLabel('Today');
                      setPage(1);
                      setSelectDateRange([
                        {
                          startDate: new Date(),
                          endDate: new Date(),
                          key: 'selection',
                        },
                      ]);
                      getSearchProviderData(
                        1,
                        searchValue,
                        selectSort,
                        selectSortOrder,
                        selectFilter,
                        selectCountry,
                        selectCity,
                        [
                          {
                            startDate: new Date(),
                            endDate: new Date(),
                            key: 'selection',
                          },
                        ]
                      );
                    }}
                  >
                    <FormattedMessage id="Clear" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="#292D32"
                    fontFamily="Akkurat"
                    onClick={() => {
                      setSelectDateRange(dateRangeState);
                      setIsModalActive(false);
                      setPage(1);
                      getSearchProviderData(
                        1,
                        searchValue,
                        selectSort,
                        selectSortOrder,
                        selectFilter,
                        selectCountry,
                        selectCity,
                        dateRangeState
                      );
                    }}
                  >
                    <FormattedMessage id="Apply" />
                  </ReusableButton>
                </Stack>
              </Row>
            </Box>
          }
        />
        {/* DateRange Select Modal  */}
      </Col>
    </Row>
  );
};

export default SuperAdminProvider;
